<template>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">Manuel Bonus Raporları</h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <router-link tag="li" to="/" class="breadcrumb-item">
                                <a>Anasayfa</a>
                            </router-link>
                            <li class="breadcrumb-item active">Manuel Bonus Raporları</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->

        <!-- Main content -->
        <div class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-header card-title">
                                Manuel Bonus Raporları
                                <button class="btn btn-outline-primary btn-sm float-right" @click="refreshPage"
                                    style="margin-right: 10px">
                                    <i class="fas fa-sync-alt"></i> Sayfayı Yenile
                                </button>
                            </div>
                            <div class="card-body">
                                <div class="overlay-wrapper">
                                    <div class="overlay" v-if="overlay">
                                        <i class="fas fa-3x fa-spinner fa-spin"></i>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-4 my-1">
                                            <input type="text" placeholder="Müşteri Kodu"
                                                class="form-control form-control-sm" v-model="search.code" />
                                        </div>

                                        <div class="col-xl-2 my-1">
                                            <select class="form-control form-control-sm" v-model="search.bonus">
                                                <option value="0">Bonus Seçiniz</option>
                                                <option v-for="data in bonuses" :key="data.id" :value="data.id">{{ data.name
                                                }}</option>
                                            </select>
                                        </div>
                                        <div class="col-xl-2 my-1">
                                            <select class="form-control form-control-sm" v-model="search.status">
                                                <option disabled selected>Durum Seçiniz</option>
                                                <option value="-1">Hepsi</option>
                                                <option value="1">Bonus Verildi</option>
                                                <option value="0">Bonus Verilmedi</option>
                                            </select>
                                        </div>
                                        <div class="col-xl-2 my-1">
                                            <button class="btn btn-info btn-sm w-100" @click="searchList">
                                                <i class="fas fa-search"></i> Filtrele
                                            </button>

                                        </div>
                                        <div class="col-xl-2 my-1">
                                            <button class="btn btn-danger btn-sm w-100" @click="reset">
                                                Temizle
                                            </button>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="table-responsive" style="min-height:500px;">
                                        <table class="table table-striped projects">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Müşteri Kodu</th>
                                                    <th>Tarih</th>
                                                    <th>Durum</th>
                                                    <th>Transaction ID</th>
                                                    <th>Bonus</th>
                                                    <th>Miktar</th>
                                                    <th>Değiştiren Kullanıcı</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(data, index) in datas" :key="index">
                                                    <td>{{ ++index }}</td>
                                                    <td>
                                                        {{ data.ad }} {{ data.soyad }}
                                                        <br />M.Kodu:
                                                        <b>{{ data.code }}</b>
                                                        <br />
                                                    </td>

                                                    <td>{{ data.date | DateFormat }}</td>
                                                    <td>
                                                        {{
                                                            data.isComplate
                                                            ? data.isSuccess
                                                                ? "Bonus Verildi"
                                                                : "Bonus Verilmedi"
                                                            : "İşlem Sırasında"
                                                        }}
                                                    </td>
                                                    <td>{{ data.transactionID }}</td>
                                                    <td>{{ data.bonus }}</td>
                                                    <td>{{ data.amount }}</td>
                                                    <td>{{ data.person }}</td>
                                                    <td>
                                                        <button class="btn btn-sm btn-outline-primary" @click="modal(data)">
                                                            <i class="fas fa-eye"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td v-if="datas.length == 0" colspan="7" class="text-center">Kayıt
                                                        Bulunamadı</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <pagination v-model="page" :records="rows" :per-page="count" @paginate="pagination" />
                            </div>
                        </div>

                        <!-- /.card -->
                    </div>
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>

        <div class="modal fade" id="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Manuel Bonus Detayları</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Açıklama</label>
                            <textarea v-model="data.message" class="form-control" placeholder="Açıklama giriniz"
                                disabled></textarea>
                        </div>
                    </div>

                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default" data-dismiss="modal">İptal</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
</template>
<script>
export default {
    data() {
        return {
            page: 1,
            count: 10,
            rows: 0,
            overlay: false,
            bonuses: [],
            data: [],
            datas: [],
            search: {
                code: "",
                bonus: 0,
                status: -1,
            },
        };
    },
    methods: {
        pagination(value) {
            this.getDatas();
            this.getDatas(true);
        },
        searchList(value) {
            this.page = 1;
            this.getDatas();
            this.getDatas(true);
        },
        modal(value) {
            this.data = value
            $("#modal").modal();
        },
        reset() {
            this.page = 1;
            this.search = {
                code: "",
                bonus: 0,
                status: -1,
            };
            this.getDatas();
            this.getDatas(true);
        },
        getDatas(type = false) {
            this.overlay = true;
            this.$http
                .post("Report/ListManuelBonus", {
                    code: this.search.code,
                    bonus: this.search.bonus,
                    status: this.search.status,
                    rowNumber: type,
                    page: this.page - 1,
                })
                .then((response) => {
                    if (type) this.rows = response.data;
                    else this.datas = response.data;

                    this.overlay = false;
                });
        },
        refreshPage() {
            this.page = 1;
            this.search = {
                code: "",
                bonus: 0,
                status: -1,
            };
            this.getDatas();
            this.getDatas(true);
        },
        getBonus() {
            this.$http.get("Bonus/ListAllBonuses").then((response) => {
                this.bonuses = response.data;
            });
        },
    },
    filters: {
        DateFormat(value) {
            if (!value) return "Belirtilmemiş";

            let date = value.split("T")[0].split("-");
            let time = value.split("T")[1].split(".")[0];
            return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
        },
    },
    created() {
        this.getDatas();
        this.getDatas(true);
        this.getBonus();

    },
    watch: {
        "$store.getters.getSite"() {
            this.getDatas();
            this.getDatas(true);
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Report/ManualBonusReport.vue